import React from 'react'
import { Link } from 'react-router-dom'
import { useSiteContent, sectionField } from '../../hooks/useSiteContent'

function GetInTouch() {
    const { content } = useSiteContent('contact')
    const c = (key, fallback) => sectionField(content, 'info', key, fallback)
    const address = c('address', '2690 Hiltona Street Victoria Road, New York, Canada')
    const addressLines = address.split(/\n|,/).map((s) => s.trim()).filter(Boolean)

    return (
        <div className="space">
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">{c('subtitle', 'Get In Touch')}</span>
                    <h2 className="sec-title">{c('title', 'Our Contact Information')}</h2>
                </div>
                <div className="row gy-4 justify-content-center">
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid style2">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/location-dot2.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">{c('address_label', 'Our Address')}</h6>
                                {addressLines.length ? addressLines.map((line) => (
                                    <p className="about-contact-details-text" key={line}>{line}</p>
                                )) : (
                                    <p className="about-contact-details-text">{address}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/call.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">Phone Number</h6>
                                {[c('phone_1', ''), c('phone_2', '')].filter(Boolean).map((phone) => (
                                    <p className="about-contact-details-text" key={phone}>
                                        <a href={`tel:${phone.replace(/\s+/g, '')}`}>{phone}</a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/mail.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">Email Address</h6>
                                {[c('email_1', ''), c('email_2', '')].filter(Boolean).map((email) => (
                                    <p className="about-contact-details-text" key={email}>
                                        <a href={`mailto:${email}`}>{email}</a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetInTouch
